module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user != '') ? _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLHeader'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    staticClass: "back-button",
    staticStyle: {
      "margin-bottom": "25px"
    },
    attrs: {
      "to": {
        path: '/palyazatok'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/img/grey-arrow.png",
      "alt": ""
    }
  }), _vm._v("Vissza")]), _vm._v(" "), (_vm.form.fields != undefined && _vm.form.fields.length > 0 && _vm.form.fields[0].childs.length > 0 && (_vm.form.vue_component == null || _vm.form.vue_component == '')) ? _c('Form', {
    attrs: {
      "field": _vm.form.fields[0],
      "childs": _vm.form.fields[0].childs,
      "form": _vm.form
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.vue_component == 'NemzetiFelsooktatasiOsztondij') ? _c('NemzetiFelsooktatasiOsztondij') : _vm._e(), _vm._v(" "), (_vm.form.vue_component == 'UtanpotlasHallgatoiOsztondij') ? _c('UtanpotlasHallgatoiOsztondij') : _vm._e(), _vm._v(" "), (_vm.form.vue_component == 'Unkp') ? _c('Unkp') : _vm._e(), _vm._v(" "), (_vm.form.vue_component == 'Unkp2021') ? _c('Unkp2021') : _vm._e(), _vm._v(" "), (_vm.form.vue_component == 'Unkp2022') ? _c('Unkp2022') : _vm._e(), _vm._v(" "), (_vm.form.vue_component == 'Unkp2023') ? _c('Unkp2023') : _vm._e(), _vm._v(" "), (_vm.form.vue_component == 'EKOP2024') ? _c('EKOP2024') : _vm._e(), _vm._v(" "), (_vm.form.vue_component == 'EKOP2025') ? _c('EKOP2025') : _vm._e(), _vm._v(" "), (_vm.form.vue_component == 'DoktoriProgram') ? _c('DoktoriProgram') : _vm._e(), _vm._v(" "), (_vm.form.vue_component == 'RendkivuliSzocialisOsztondij') ? _c('RendkivuliSzocialisOsztondij') : _vm._e(), _vm._v(" "), (_vm.form.vue_component == 'KiemelkedoTudomanyosSportKulturalisOsztondij') ? _c('KiemelkedoTudomanyosSportKulturalisOsztondij') : _vm._e()], 1)]), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProfileMenu')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage-head-image",
    staticStyle: {
      "background-image": "url('assets/img/subpage-head.jpg')"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n        Pályázatra jelentkezés\n        "), _c('span', [_vm._v("Jelentkezés pályázatra")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13a552ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/form.vue
// module id = 332
// module chunks = 0